import type { canv } from "@/canv/global";
import { AiAnswer } from "@/elements/aiAnswer";
import { AI_TEXT_HARD_WIDTH } from "@/elements/aiAnswer/constants";
import { Group } from "@/group";
import { TEXT_WIDGET_LEFT_MARGIN } from "../constants/aiConstants";
import type { CreateSubMenuActions } from "../types";

export function createAiAnswerWidget(action: CreateSubMenuActions, canvInstance: typeof canv) {
    const { startX, startY, width } = canvInstance.canvasController;

    const xForTextWidget = startX + width + TEXT_WIDGET_LEFT_MARGIN;

    const newAiAnswerWidget = new AiAnswer(xForTextWidget, startY, action);
    newAiAnswerWidget.generatedText.setResizeMode("shape");
    newAiAnswerWidget.generatedText.hardWidth = AI_TEXT_HARD_WIDTH;

    const newGroup = new Group(true);
    newAiAnswerWidget.setParent(newGroup);
    canvInstance.canvasController.addGroup(newGroup);

    canvInstance.eventManager.openRecord();
    canvInstance.eventManager.createBuildEvent("create", newGroup);
    canvInstance.eventManager.closeRecord();

    return newAiAnswerWidget.UID;
}
